import script from "./LeadsListView.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadsListView.vue?vue&type=script&setup=true&lang=js"

import "./LeadsListView.vue?vue&type=style&index=0&id=29b991c7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29b991c7"]])

export default __exports__